import { render, staticRenderFns } from "./PLoader.vue?vue&type=template&id=80fd76b4&"
import script from "./PLoader.vue?vue&type=script&lang=js&"
export * from "./PLoader.vue?vue&type=script&lang=js&"
import style0 from "./PLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports